import { render, staticRenderFns } from "./JdsWorkbench.vue?vue&type=template&id=86acc796&scoped=true&"
import script from "./JdsWorkbench.vue?vue&type=script&lang=ts&"
export * from "./JdsWorkbench.vue?vue&type=script&lang=ts&"
import style0 from "./JdsWorkbench.vue?vue&type=style&index=0&id=86acc796&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86acc796",
  null
  
)

export default component.exports